module.exports = __webpack_public_path__ + "static/img/3.794be8e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/3.jpg
// module id = Vr8m
// module chunks = 0